export default __webpack_public_path__ + "static/media/asset06.bd267cad.png";